import useLayerListeners from './useLayerListeners';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import { Ref, WatchStopHandle } from 'vue';
import { LAYER_CONFIG_OMIT_PROP } from '../constants';

export default function useMarkerLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<MarkerLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config) return;

  const { id: layerId } = layerInfo.value;

  const { data, onClick, onHover } = toRefs(reactive(layerInfo.value.config));

  if (!data.value.length) return;

  let markerStyle; let geometries;
  let unwatchList: WatchStopHandle[] | null = [];

  const markerLayer = new JUE.MultiMarker({
    id: layerId,
    map: mapInstance,
  });

  unwatchList.push(watchEffect(() => {
    const styleConfig = omit(layerInfo.value.config, LAYER_CONFIG_OMIT_PROP);
    const styleOption = mapValues(styleConfig, val => toRaw(unref(val)));
    if (!styleOption.src) delete styleOption.src; // 未传src时去掉，避免GL报错
    markerStyle = new JUE.MarkerStyle(styleOption);
    if (markerLayer) markerLayer.setStyles({ markerStyle });
  }));

  unwatchList.push(watchEffect(() => {
    if (!Array.isArray(data.value)) return;
    geometries = data.value.map((geometry: MarkerGeometry, index: number) => {
      const { id, position, rank } = geometry;
      return {
        id: id ? id : `${index}`,
        position: new JUE.LatLng(position.lat, position.lng, position.height),
        rank: rank ? rank : index,
        styleId: 'markerStyle',
      };
    });
    if (markerLayer) markerLayer.setGeometries(geometries);
  }));

  // 用户传入的事件回调在这里处理
  unwatchList.push(watchEffect(() => {
    useLayerListeners(markerLayer, [
      { eventName: 'click', callbackList: onClick?.value },
      { eventName: 'hover', callbackList: onHover?.value },
    ]);
  }));

  markerLayer.unmount = (): void => {
    markerLayer?.destroy();
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };

  return markerLayer;
}
